var View = require('views/base/view');

var TitlebarView = View.extend({
	template: require('./templates/titlebar')
});

module.exports = TitlebarView;